import axios from 'axios';
import router from '@/router';

const instance = axios.create({
   baseURL: 'https://api.prokat1.by'
   //baseURL: 'http://arenda-backend'
});

instance.interceptors.request.use(config => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});

instance.interceptors.response.use(response => response, error => {
    if (error.response && error.response.status === 401) {
        router.push({ name: 'Signin' });
    }
    return Promise.reject(error);
});

export default instance;
